// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS component definition */

.ComboboxInput-module__Container__gwVRq {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    padding: var(--ds-s) var(--ds-10x) var(--ds-s) var(--ds-s);
    background-color: var(--ds-input-field-bg-color);
    border-radius: var(--ds-border-radius-sm);
    box-shadow: 0 0 0 var(--ds-border-width) var(--ds-input-field-border-color)
        inset;
    transition: all var(--ds-transition-s) ease-in-out;
}

.ComboboxInput-module__ContainerPointer__VEiZG {
    cursor: pointer;
}

.ComboboxInput-module__Container__gwVRq:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-hover-border-color) inset;
}

.ComboboxInput-module__Error__Jrni3 {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-error-border-color) inset;
}

.ComboboxInput-module__Error__Jrni3:hover {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-error-border-color) inset;
}

.ComboboxInput-module__Disabled__Pn9Ga {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
}

.ComboboxInput-module__Disabled__Pn9Ga:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
}

.ComboboxInput-module__ReadOnly__OrXKR {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-readonly-border-color) inset;
}

.ComboboxInput-module__ReadOnly__OrXKR:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-readonly-border-color) inset;
}

.ComboboxInput-module__MultiselectInputContainer__zkV8H {
    flex-wrap: wrap;
}

.ComboboxInput-module__Focused__oquIR {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.ComboboxInput-module__Focused__oquIR:hover {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.ComboboxInput-module__ValuesContainer__Grhd0 {
    display: flex;
    flex-wrap: wrap;
    gap: var(--ds-s);
    align-items: center;
    width: 100%;
    min-width: 0;
}

.ComboboxInput-module__Input__EoQXJ {
    all: unset;
    flex: 1;
    min-width: 0;
    padding: var(--ds-xs);
    color: var(--ds-input-field-text-color);
    font-size: var(--ds-font-size-m);
    line-height: var(--ds-line-height-big);
    border: none;
}

.ComboboxInput-module__Input__EoQXJ:disabled {
    color: var(--ds-input-field-disabled-text-color);
}

.ComboboxInput-module__Input__EoQXJ:disabled::placeholder {
    color: var(--ds-input-field-disabled-placeholder-color);
}

.ComboboxInput-module__InputReadOnly__A4vfW {
    color: var(--ds-input-field-readonly-text-color);
}

.ComboboxInput-module__InputSelectOnly__CXyF1 {
    caret-color: transparent;
}

.ComboboxInput-module__InputBehindCustomDisplay__b1CL6 {
    color: transparent;
    caret-color: transparent;
    /* stylelint-disable-next-line selector-max-specificity -- hides the selection of the value drawn by renderOption */
    &::selection {
        background-color: transparent;
    }
}

.ComboboxInput-module__Input__EoQXJ::placeholder {
    color: var(--ds-input-field-placeholder-color);
    font-size: var(--ds-font-size-m);
}

.ComboboxInput-module__CustomDisplay__b3MAV {
    display: flex;
    gap: var(--ds-m);
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 var(--ds-s);
    color: var(--ds-font-color-accent);
    font-weight: var(--ds-font-weight-regular);
    font-size: var(--ds-font-size-m);
    line-height: var(--ds-line-height-big);
}

.ComboboxInput-module__Toggle__unaXl {
    all: unset;
    position: absolute;
    right: var(--ds-m);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ds-input-field-icon-color);
    background-color: transparent;
    cursor: pointer;
    transition: all var(--ds-transition-s) ease-in-out;
}

.ComboboxInput-module__Toggle__unaXl:hover {
    color: var(--ds-input-field-focused-icon-color);
}

.ComboboxInput-module__ToggleDisabled__MOfQC {
    color: var(--ds-input-field-disabled-icon-color);
    cursor: default;
}

.ComboboxInput-module__ToggleDisabled__MOfQC:hover {
    color: var(--ds-input-field-disabled-icon-color);
}

.ComboboxInput-module__ToggleExpanded__Y7lNF {
    color: var(--ds-input-field-focused-icon-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ComboboxInput-module__Container__gwVRq`,
	"ContainerPointer": `ComboboxInput-module__ContainerPointer__VEiZG`,
	"Error": `ComboboxInput-module__Error__Jrni3`,
	"Disabled": `ComboboxInput-module__Disabled__Pn9Ga`,
	"ReadOnly": `ComboboxInput-module__ReadOnly__OrXKR`,
	"MultiselectInputContainer": `ComboboxInput-module__MultiselectInputContainer__zkV8H`,
	"Focused": `ComboboxInput-module__Focused__oquIR`,
	"ValuesContainer": `ComboboxInput-module__ValuesContainer__Grhd0`,
	"Input": `ComboboxInput-module__Input__EoQXJ`,
	"InputReadOnly": `ComboboxInput-module__InputReadOnly__A4vfW`,
	"InputSelectOnly": `ComboboxInput-module__InputSelectOnly__CXyF1`,
	"InputBehindCustomDisplay": `ComboboxInput-module__InputBehindCustomDisplay__b1CL6`,
	"CustomDisplay": `ComboboxInput-module__CustomDisplay__b3MAV`,
	"Toggle": `ComboboxInput-module__Toggle__unaXl`,
	"ToggleDisabled": `ComboboxInput-module__ToggleDisabled__MOfQC`,
	"ToggleExpanded": `ComboboxInput-module__ToggleExpanded__Y7lNF`
};
export default ___CSS_LOADER_EXPORT___;
